import { render, staticRenderFns } from "./NotificationsOptionsPopover.vue?vue&type=template&id=53279608&scoped=true&"
import script from "./NotificationsOptionsPopover.vue?vue&type=script&lang=js&"
export * from "./NotificationsOptionsPopover.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsOptionsPopover.vue?vue&type=style&index=0&id=53279608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53279608",
  null
  
)

export default component.exports